import { render, staticRenderFns } from "./ExamGroupIndex.vue?vue&type=template&id=402ba7cb&"
import script from "./ExamGroupIndex.vue?vue&type=script&lang=ts&"
export * from "./ExamGroupIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports